export const opportunityStatuses = [
  "Introduced",
  "Contacted",
  "Discovery in progress",
  "Solution design",
  "Proposal submitted",
  "Client reviewing",
  "Commercial negotiation",
  "Contracting",
  "Payment pending",
  "Paid - delivery pending",
  "Delivery in progress",
  "Live - post-launch support",
  "Completed",
  "On hold",
  "Closed - not proceeding",
] as const;

export type OpportunityStatus = (typeof opportunityStatuses)[number];
export type Role = "bai_admin" | "supplier_updater";
export type ReminderWeekday =
  | "Monday"
  | "Tuesday"
  | "Wednesday"
  | "Thursday"
  | "Friday"
  | "Saturday"
  | "Sunday";

export interface ReminderSettings {
  weekday: ReminderWeekday;
  hour: number;
  timezone: "Asia/Hong_Kong";
}

export interface UserSession {
  accessToken: string;
  displayName: string;
  email: string;
  role: Role;
  supplierOrganizationId?: string;
}

export interface ClientReference {
  id: string;
  displayName: string;
  market: string;
}

export interface Opportunity {
  id: string;
  clientReference: ClientReference;
  projectName: string;
  projectSummary: string;
  status: OpportunityStatus;
  nextCheckInOn: string;
  reviewOn?: string;
  assignedOn: string;
  isOverdue: boolean;
  supplierName: string;
  lastUpdateNote?: string;
  updatedAt: string;
}

export interface OpportunityUpdateInput {
  status: OpportunityStatus;
  nextCheckInOn: string;
  note?: string;
  reason?: string;
  reviewOn?: string;
  attachments?: Attachment[];
  files?: File[];
}

export interface Attachment {
  id: string;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  downloadUrl?: string;
}

export interface OpportunityUpdate {
  id: string;
  opportunityId: string;
  occurredAt: string;
  actorName: string;
  previousStatus: OpportunityStatus;
  status: OpportunityStatus;
  nextCheckInOn?: string;
  reviewOn?: string;
  note?: string;
  reason?: string;
  attachments: Attachment[];
}

export interface DashboardSummary {
  totalActive: number;
  overdue: number;
  dueThisWeek: number;
  confirmed: number;
}

export interface Invitation {
  id: string;
  email: string;
  supplierName: string;
  expiresAt: string;
  status: "pending" | "accepted" | "expired" | "revoked";
}

export interface AuditEvent {
  id: string;
  occurredAt: string;
  actorName: string;
  action: string;
  entityType: string;
  summary: string;
  attachments?: Attachment[];
}
